import { STATIC_STRINGS } from "@asez/shared";
import { FILTER_KEYS } from "@asez/shared";
import { FilterListItem } from "./FilterListItem";
import { initialFilters } from "./index";

const ProgressOptions = STATIC_STRINGS.PROGRESS_OPTIONS;

export const ProgressFilter = ({ filters, updateFilters }) => {
  return (
    <FilterListItem
      filterName={STATIC_STRINGS.PROGRESS}
      resetHandler={() => {
        updateFilters(
          FILTER_KEYS.PROGRESS_STATUS,
          initialFilters[FILTER_KEYS.PROGRESS_STATUS]
        );
      }}
      Component={
        <div className="flex justify-start items-center w-full">
          {ProgressOptions.map((status) => (
            <div
              key={status}
              className={`p-2 mr-2 rounded-lg text-sm font-medium transition duration-300 border-2 border-neutral-dark text-primary hover:bg-neutral hover:text-white cursor-pointer ${
                filters[FILTER_KEYS.PROGRESS_STATUS] === status &&
                `text-white bg-neutral-dark`
              }`}
              onClick={() => updateFilters(FILTER_KEYS.PROGRESS_STATUS, status)}
            >
              {status}
            </div>
          ))}
        </div>
      }
    />
  );
};
